<template>
  <div>
    <div class="question-card">
      <div class="flex jc-between p-x-3">
        <div>
          Вопрос: {{currentStep+1}}/{{ this.data.questions.length }}
        </div>
        <!-- <div>
          Решено: 0/8
        </div> -->
      </div>
      <div class="question-stepper">
        <div>
          <div class="stepper-steps">
            <div class="stepper-step" 
              v-for="(item, key) in this.data.questions" 
              :class="{'active': key == currentStep}"
              :key="item.id" 
              @click="changeStep(key)">
              <div class="flex ai-center jc-center">
                {{ key+1 }}
              </div>
            </div>
          </div>
          <div class="stepper-items m-t-8">
            <div
              class="stepper-item" 
              v-for="(item, key) in this.data.questions" :key="item.id" 
              :class="{'active': key == currentStep}"
              
              >
              <template v-if="key == currentStep">
                <div class="ta-center m-b-10">
                  <div class="text-x10 m-b-3" v-html="item.title"></div>
                  <div class="text-x4" v-html="item.description"></div>
                </div>
                <div class="question-item">
                  <component
                    :is="`type-${item.type}`"
                    @preAnswer="preAnswer"
                    :data="item"
                  />
                </div>
              </template>
            </div>
          </div>
          <div class="stepper-prevnext m-t-8">
            <div class="flex jc-between">
              <div>
                <span class="btn-def bg-color-2" v-if="currentStep > 0">
                  <button class="p-x-8" @click="prev()">Предыдущий</button>
                </span>
              </div>
              <div>
                <span class="btn-def bg-color-3" v-if="currentStep < this.data.questions.length-1">
                  <button class="p-x-8" @click="next()">Следующий</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      currentStep: 0,
      questions: null,
    };
  },
  components: {
    "type-order": () => import("./Type/QuestionTypeOrder"),
    "type-glue": () => import("./Type/QuestionTypeGlue"),
    "type-text": () => import("./Type/QuestionTypeText"),
    "type-test": () => import("./Type/QuestionTypeTest"),
    "type-upload": () => import("./Type/QuestionTypeUpload"),
    "type-dropdown": () => import("./Type/QuestionTypeDropdown"),
    "type-miss-word": () => import("./Type/QuestionTypeMissWord"),
    "type-drag-and-drop": () => import("./Type/QuestionTypeDragAndDrop"),
  },
  watch: {},
  computed: {

  },
  props: ['data'],
  mounted() {
    
    
      
  },
  methods: {
    next(){
      if(this.data.questions.length-1 > this.currentStep)
        this.currentStep++
    },
    prev(){
      if(this.currentStep > 0)
        this.currentStep--
    },
    changeStep(stepKey){
      this.currentStep = stepKey
    }
  },

};
</script>

